var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectUiDefinition } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { componentFromType } from "../generic/componentFromType";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { MarketFooter } from "./MarketFooter";
var MenuMarketDOM = /** @class */ (function (_super) {
    __extends(MenuMarketDOM, _super);
    function MenuMarketDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuMarketDOM.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, tabId = _a.tabId;
        var footerComponent = componentFromType(MarketFooter);
        return (React.createElement(MenuWrapper, { onClose: onClose, footerRenderer: footerComponent, className: "market-dialog", type: IdMenuBalancing.Market, modalId: IdModal.Market, activeTabIndex: tabId }));
    };
    return MenuMarketDOM;
}(React.PureComponent));
var mapState = function (state) {
    var tabs = selectUiDefinition(IdMenuBalancing.Market).category;
    var activeTabId = selectModalTabId(state, IdModal.Market);
    var tabIndex = 0;
    if (tabs != undefined && activeTabId != undefined) {
        tabIndex = tabs.findIndex(function (tab) { return tab.id === activeTabId; });
    }
    return {
        tabId: tabIndex,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.Market)); },
}); };
export var MenuMarket = connect(mapState, mapDispatch)(MenuMarketDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MenuMarket.tsx
// module id = 2846
// module chunks = 3